/* 1) Custom list (identical) ---------------------------------------- */
const customSortOrder = {
  "all-products": ["new-ultra-potent-hormone-harmony", "the-complete-gut-repair", "ultimate-weight-loss-support", "metabolic-harmony", "new-improved-protocol", "hormone-harmony-plus", "the-complete-belly-reset", "estro-control",  "the-bloat-banisher", "complete-hormone-synergy-system", "the-deep-sleep-mode", "new-fatigue-eliminator", "colostrum-breakthrough", "fitslim-supergreens", "magnesium", "ultimate-glucose-support", "advanced-glucose-support",  "the-complete-detox-package", "vitaminboost", "boostwithb", "calcium", "zinc"],
  "hormone-health": ["new-ultra-potent-hormone-harmony", "hormone-harmony-plus", "estro-control"],
  "weight-loss": ["new-improved-protocol", "ultimate-weight-loss-support", "metabolic-harmony", "ultimate-glucose-support",  "advanced-glucose-support", "fitslim-supergreens"],
  "vitamins": ["magnesium", "vitaminboost", "boostwithb", "calcium", "zinc"],
  "gut-health": ["the-complete-gut-repair", "the-complete-belly-reset", "the-bloat-banisher", "colostrum-breakthrough"],
  "bundles": ["new-improved-protocol", "complete-hormone-synergy-system", "the-complete-detox-package"]
  };

jQuery(function ($) {
  /* 2) Cache basics -------------------------------------------------- */
  const $grid   = $(".bf-grid-col");               // must be display:flex or grid
  const $blocks = $(".bf-grid-block");
  const byHandle = {};
  $blocks.each(function () {
    const h = $(this).data("filter-handle");
    (byHandle[h] = byHandle[h] || []).push(this);
  });

  /* 3) Click handlers ------------------------------------------------ */
  $("#bfcat-terms").on("click", ".filter-btn", function (e) {
    e.preventDefault();
    const cat = $(this).data("category");
    setActive(this);
    history.pushState(null, "", "#" + cat);
    filterAndOrder(cat);
  });

  /* 4) First run (respect URL hash) --------------------------------- */
  const start = customSortOrder[location.hash.slice(1)]
              ? location.hash.slice(1) : "all-products";
  setActive($(`.filter-btn[data-category='${start}']`));
  filterAndOrder(start);

  /* 5) Resize hook for equal-height --------------------------------- */
  $(window).on("load resize", equalHeights);

  /* ---------------------------- Core ------------------------------ */
  function filterAndOrder(cat) {
    const list   = customSortOrder[cat] || [];
    const max    = 9999;                           // order used for hidden/others
    let current  = 0;

    /* a) assign order values */
    $blocks.each(function () { this.style.order = max; });  // reset first
    list.forEach(h =>
      (byHandle[h] || []).forEach(el => { el.style.order = current++; })
    );
    if (cat === "all") {
      /* orphans get order after the defined list */
      $blocks.filter(function () { return this.style.order == max; })
             .each(function () { this.style.order = current++; });
    }

    /* b) visibility */
    $blocks.hide();
    list.forEach(h => (byHandle[h] || []).forEach(el => el.style.display = ""));
    if (cat === "all") $blocks.show();

    /* c) misc hooks */
    $(".cm-header").attr("data-bf-category", cat);
    equalHeights();

    /* d) DEBUG LOG */
    console.log(`🌀 filterAndOrder("${cat}") → ${list.length} handles,`,
                `order 0-${current-1} set`);
  }

  /* ---------------------------- Helpers --------------------------- */
  function setActive(btn) {
    $(".filter-btn").removeClass("active");
    $(btn).addClass("active");
  }

  function equalHeights() {
    const items = Array.from(document.querySelectorAll(".bf-grid-block"));
    let i = 0;
    while (i < items.length) {
      const rowY = items[i].getBoundingClientRect().top;
      let j = i, maxH = 0;
      for (; j < items.length && items[j].getBoundingClientRect().top === rowY; j++) {
        const top = items[j].querySelector(".bf-grid-top");
        top.style.height = "auto";
        maxH = Math.max(maxH, top.offsetHeight);
      }
      for (let k = i; k < j; k++) {
        items[k].querySelector(".bf-grid-top").style.height = maxH + "px";
      }
      i = j;
    }
  }

  /* ---------------------------- DEBUG API ------------------------- */
  window.debugFilter = function (cat) { filterAndOrder(cat); };
  window.debugOrder  = function () {
    return [...$blocks].map(el => ({
      handle : el.dataset.filterHandle,
      order  : el.style.order
    }));
  };
  console.log(
    "%cFlex-order filter loaded.\n" +
    "• debugFilter('gut-health') to test.\n" +
    "• debugOrder() to list current order values.",
    "color:#0a0;font-weight:bold;"
  );
});